import { LoadingIcon } from '@/components/icons';
import { Breakpoints } from '@/utils/Breakpoint';
import { ClassNameComponent } from '@/utils/ClassNameComponent';
import { CheckIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import ConditionalRenderer from '../ConditionalRenderer';
import Text from './Text';

type SaveStatusProps = {
  isLoading?: boolean;
  hasChanges?: boolean;
  className?: Pick<ClassNameComponent, 'base'>;
};

const SaveStatus = ({ isLoading, hasChanges, className }: SaveStatusProps) => {
  const isXsScreen = useMediaQuery({
    minWidth: Breakpoints.xs,
  });
  const { t } = useTranslation('translation', {
    keyPrefix: 'section.form',
  });
  return (
    <div className={className?.base}>
      <ConditionalRenderer condition={isLoading}>
        <LoadingIcon className="text-secondary w-5 h-5" />
      </ConditionalRenderer>
      <ConditionalRenderer condition={!isLoading && hasChanges}>
        <div className="flex gap-1 items-center">
          <CheckIcon className="text-success w-4 h-4" />
          {isXsScreen && (
            <Text className="text-14 text-success" text={t('save')} />
          )}
        </div>
      </ConditionalRenderer>
    </div>
  );
};

export default SaveStatus;
